import { JSX } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, Collapse, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ErrorAlertProps {
  error: string | null;
  setError: (error: string | null) => void;
}

const ErrorAlert = ({ error, setError }: ErrorAlertProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!error) return null;

  return (
    <Box width='100%'>
      <Collapse in>
        <Alert
          severity='error'
          action={
            <IconButton aria-label='close' color='inherit' size='small' onClick={() => setError(null)}>
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
        >
          {t(error)}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default ErrorAlert;
